module.exports = __webpack_public_path__ + "static/media/icn_programme_active.7fdf6c30.svg";